export const convertSearchObjectToBase64 = ( param ) => {
  let tmp = JSON.stringify( param )
  return Buffer.from( tmp ).toString( 'base64' )
}

export const convertObjToBase64 = param => {
  let queryJSON = JSON.stringify( param )
  return Buffer.from( queryJSON ).toString( 'base64' )
}
